import axios from "axios";

export const deleteKeyPerson = (
  keyPersonId: number,
  sessionId: string | null
) => {
  return axios
    .post(
      `${process.env.REACT_APP_BASE_URL}api/delete/one/tradexwbench.customer_key_person/${keyPersonId}`,
      {},
      {
        headers: {
          Authorization: `Bearer ${sessionId}`,
        },
      }
    )
    .then((response) => {
      return response;
    })
    .catch((err) => err);
};
